import { emptyArray } from 'ui-components/default-props/empty';
import { HandlingUnitPresetSortColumn, OrderByDirection } from '@shipstation/client-common/types/freight-requests';

import type { HandlingUnitPresetsState } from './ltl.handling-unit-presets.reducer';

export const selectHandlingUnitPresetGridCurrentPageIds = (state: HandlingUnitPresetsState) =>
  state.currentPageHandlingUnitPresetIds ?? emptyArray;

export const selectHandlingUnitPresetGridPage = (state: HandlingUnitPresetsState) => state.page ?? 1;

export const selectHandlingUnitPresetGridPageSize = (state: HandlingUnitPresetsState) => state.pageSize ?? 50;

export const selectHandlingUnitPresetGridTotalCount = (state: HandlingUnitPresetsState) => state.totalRecords ?? 0;

export const selectHandlingUnitPresetGridIsLoading = (state: HandlingUnitPresetsState) => state.isLoading ?? false;

export const selectHandlingUnitPresetGridIsSaving = (state: HandlingUnitPresetsState) => state.isSaving ?? false;

export const selectHandlingUnitPresetGridIsSaveError = (state: HandlingUnitPresetsState) => state.isSaveError ?? false;

export const selectHandlingUnitPresetGridSearchTerm = (state: HandlingUnitPresetsState) => state.searchTerm ?? '';

export const selectHandlingUnitPresetGridOrderBy = (state: HandlingUnitPresetsState) => state.orderBy ?? HandlingUnitPresetSortColumn.Name;

export const selectHandlingUnitPresetGridOrderByDirection = (state: HandlingUnitPresetsState) =>
  state.orderByDirection ?? OrderByDirection.Ascending;

export const selectHandlingUnitPresetGridSelectedIds = (state: HandlingUnitPresetsState) =>
  state.selectedHandlingUnitPresetIds ?? emptyArray;
